var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-container"},[_vm._v("We use "),_c('b',[_vm._v("Stripe's Connect Account")]),_vm._v(" service to process online orders. To ensure swift approval, valid business and tax information are required. When all details are accurate, account approval can be completed within minutes.")])
}]

export { render, staticRenderFns }